import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
    Grid,
    Heading,
    GridItem,
    useColorModeValue,
    useColorMode,
} from '@chakra-ui/react';
import { useBreakpointValue } from '@chakra-ui/react';
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import Boxx from '../../components/common/boxhome/boxx';
import Footer from "../../components/footer/footer";
import Lottie from 'lottie-react';
import Ai from '../../lotti-file/digitalbranding/digitalbranding.json';
import Ai1 from '../../lotti-file/digitalbranding/digitalbranding.json';
import Ai2 from '../../lotti-file/digitalbranding/product.json';
import Ai3 from '../../lotti-file/digitalbranding/contactwriting.json';
import Ai4 from '../../lotti-file/digitalbranding/productpacking.json';
import Ai5 from '../../lotti-file/digitalbranding/productphotography.json';
import Ai6 from '../../lotti-file/digitalbranding/usergentereted.json';

import Ai7 from '../../lotti-file/digitalbranding/brandingwhite.json';
import Ai8 from '../../lotti-file/digitalbranding/productwhite.json';
import Ai9 from '../../lotti-file/digitalbranding/contentwritingwhite.json';
import Ai10 from '../../lotti-file/digitalbranding/productpackingwhite.json';
import Ai11 from '../../lotti-file/digitalbranding/productphotographywhite.json';
import Ai12 from '../../lotti-file/digitalbranding/usergeneratedwhite.json';
import { useLocation, useNavigate } from 'react-router-dom';



const solutions = [
    { title: "Digital Branding Solutions", path: "/digitalbranding" },
    { title: "Awareness Growth Solutions", path: "/awarenesssoutions" },
    { title: "Revenue Growth Solutions", path: "/revenuegrowth" },
    { title: "Social Media Management", path: "/socialmedia" },
    { title: "SEO", path: "/seo" },
    { title: "Performance Marketing", path: "/performancemarketing" },
];


const services = [
    { title: <Text as="span">Branding <Text as="span" color="#FE3A3A">Design</Text> </Text>, description: 'Craft your unique brand identity, including logos, typography, and visual guidelines that communicate your core values.', animationDataLight: Ai7, animationDataDark: Ai1, },
    { title: <Text as="span">Product Content <Text as="span" color="#FE3A3A">Design</Text> </Text>, description: 'Compelling product visuals and content to enhance your product\'s appeal across platforms and drive engagement.', animationDataLight: Ai8, animationDataDark: Ai2 },
    { title: <Text as="span">Content <Text as="span" color="#FE3A3A">Writing</Text> </Text>, description: 'Design creative and engaging social media content for impactful campaigns.', animationDataLight: Ai9, animationDataDark: Ai3 },
    { title: <Text as="span">Product <Text as="span" color="#FE3A3A">Packaging</Text></Text>, description: 'Craft interactive and intuitive user interfaces to enhance your website’s user experience.', animationDataLight: Ai10, animationDataDark: Ai4 },
    { title: <Text as="span">Product Photography &<Text as="span" color="#FE3A3A"> Reels</Text></Text>, description: 'Design personalized and attention-grabbing email templates for better conversions.', animationDataLight: Ai11, animationDataDark: Ai5 },
    { title: <Text as="span">User Generated <Text as="span" color="#FE3A3A">Content</Text> (UGC)</Text>, description: 'Design engaging promotional material to complement your marketing campaigns.', animationDataLight: Ai12, animationDataDark: Ai6 }
];

const Digitalbranding: React.FC = () => {
    const { colorMode } = useColorMode();

    const navigate = useNavigate();
    const scrollRef = useRef<HTMLDivElement>(null);
    const pathData = useBreakpointValue({
        base: "M0 10 Q75 0 200 10",
        md: "M0 20 Q150 0 300 20"
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const selectedIndex = solutions.findIndex((solution) => solution.path === location.pathname);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [selectedMenu, setselectedMenu] = useState({

    })

    const handleSolutionClick = (index: number, path: string) => {

        setLoading(true);

        setTimeout(() => {

            navigate(path);
        }, 500);
    };

    useEffect(() => {
        if (selectedIndex !== null && itemRefs.current[selectedIndex]) {
            itemRefs.current[selectedIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',

            });
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

    }, [selectedIndex, location.pathname]);


    const bg = useColorModeValue('white', '#1C1C1C');
    const color = useColorModeValue('#FFFFF', 'white');
    const textColor = useColorModeValue('#1C1C1C', 'white');
    const selectedTextColor = 'white';

    const gridTemplateColumns = useBreakpointValue({
        base: '1fr',
        md: 'repeat(2, 1fr)'
    });


    return (
        <Grid
            bg={bg}
            templateColumns="1fr"
            gap={4}
            p={4}
            width="full"
            marginTop="auto"
        >
            {/* Heading Section */}
            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text fontSize={{ base: "12px", md: "28px" }} lineHeight="36px" fontWeight="400" color={color}>
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>Service /{' '}</span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>Digital Branding Solutions</span>
                </Text>
                <Box mt="10px" display="inline-block" ml={{ base: '90px', md: '120px' }} >
                    <svg width="100%" height="auto" viewBox="0 0 300 40" >
                        <path d={pathData} fill="none" stroke={colorMode === 'light' ? 'black' : 'silver'}
                            strokeWidth="2" />
                    </svg>
                </Box>
            </Box>

            {/* "What We Offer" Title */}
            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text fontSize={{ base: "32px", md: "64px" }} lineHeight={{ base: "40px", md: "78px" }} fontWeight="400" color={color}>
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>What {' '}</span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>we offer</span>
                </Text>
            </Box>

            {/* Solutions Section */}
            <Box
                ref={scrollRef}
                overflowX="auto"
                whiteSpace="nowrap"
                flexGrow={1}
                p={1}
                width="full"
                sx={{
                    '::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                <Flex
                    width="100%"
                    gap={6}
                    flexDirection="row"
                    overflowX="auto"
                    padding="10px"
                    color={useColorModeValue('#FFFFF', '#FFFFF')}
                    maxWidth="100%"
                    sx={{
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                    }}
                >
                    {solutions.map((solution, index) => (
                        <Box
                            key={solution.title}
                            ref={(el) => itemRefs.current[index] = el}
                            onClick={() => handleSolutionClick(index, solution.path)}
                            borderRadius="md"
                            padding="10px"
                            fontFamily="'Gilroy-Regular', sans-serif"
                            cursor="pointer"
                            transition="background-color 0.3s"
                            bg={selectedIndex === index ? 'red.500' : 'transparent'}
                            flexShrink={0}
                        >
                            <Text
                                fontSize={{ base: "20px", md: "28px" }}
                                color={selectedIndex === index ? selectedTextColor : textColor}
                            >
                                {solution.title}
                            </Text>
                        </Box>
                    ))}
                </Flex>
            </Box>

            {/* Hero Image Section */}
            <Box
                height={{ base: "50vh", md: "100vh" }}
                width="100%"
                bg="#000000"
                backgroundImage="url('/assets/images/svg/brandingpage.jpg')"
                backgroundSize="cover"
                backgroundPosition="center"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                opacity={1}
                margin={0}
            />

            {/* Descriptions Section */}
            <Box textAlign="left" mt="10px" color={color}>
                <Text fontSize={{ base: '28px', md: '52px' }} fontFamily="'Gilroy-SemiBold', sans-serif">
                    Descriptions
                </Text>
                <Text
                    textAlign="justify"
                    fontSize={{ base: '16px', md: '28px' }}
                    lineHeight={{ base: '24px', md: '36px' }}
                    fontWeight="400"
                    fontFamily="'Gilroy-Regular', sans-serif"
                    mt="20px"
                    letterSpacing='0.5px'
                >
                    Your brand is the foundation of your business, and our Digital Branding Solutions ensure it's memorable and impactful. From crafting a distinct visual identity to developing engaging product content, we offer a full suite of services that define and elevate your brand in the digital landscape.
                </Text>
            </Box>

            {/* Services Grid */}
            <Grid
                mt="30px"
                templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
                gap={{ base: 4, md: 6 }}
                p={{ base: 2, md: 4 }}
                maxWidth="100%"
                height="auto"
                mx="auto"
                overflowX="hidden"
            >
                {services.map((service, index) => (
                    <GridItem key={index} position="relative" display="flex" justifyContent="center">
                        <Box
                            borderRadius="md"
                            p={4}
                            borderColor="gray.600"
                            mb={4}
                            textAlign="center"
                            mx="auto"
                            width="100%"

                        >
                            {/* Lottie Box */}
                            <Box
                                mb={{ base: 2, md: -5 }}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                ml={{ md: "-10px" }}
                                width={{ base: '100px', md: '255px' }}
                                height={{ base: '60px', md: '162px' }}
                                mx="auto"
                                order={{ base: 0, md: -1 }}
                            >
                                {/* Lottie Animation */}
                                <Lottie
                                    animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
                                    loop={true}
                                />
                            </Box>

                            {/* Title and Description */}
                            <Box display="flex" flexDirection="column" alignItems={{ base: 'center', md: 'flex-start' }} mt={4}>
                                <Text
                                    fontSize={{ base: '16px', md: '40px' }}
                                    fontWeight="400"
                                    color={colorMode === 'light' ? 'black' : 'white'} 
                                    whiteSpace="nowrap"
                                    overflow="visible"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                    textOverflow="ellipsis"
                                    maxWidth="100%"
                                    textAlign="center"
                                    mt={{ base: '0', md: '0' }}
                                >
                                    {service.title}
                                </Text>
                                <Text
                                    color={colorMode === 'light' ? 'black' : 'white'} 
                                    fontSize={{ base: '14px', md: '25px' }}
                                    mt={1}
                                    textAlign="justify"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                >
                                    {service.description}
                                </Text>
                            </Box>

                            {/* Gradient border */}
                            <Box
                                mt={4}
                                border="1px solid"
                                sx={{
                                    borderImageSource:
                                        colorMode === "light"
                                            ? "linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)"
                                            : "linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)",
                                    borderImageSlice: 1,
                                }}
                            />
                        </Box>

                        {/* Gradient divider between items only on larger screens */}
                        {index % 2 === 0 && index < services.length - 1 && (
                            <Box
                                display={{ base: 'none', md: 'block' }}
                                position="absolute"
                                top={0}
                                bottom={0}
                                right={0}
                                width="1px"
                                background={
                                    colorMode === 'light'
                                        ? 'linear-gradient(473deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                        : 'linear-gradient(473deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)'
                                }
                                height="100%"
                                transform="translateX(50%)"
                            />
                        )}
                    </GridItem>
                ))}
            </Grid>


            <Box mt={{ base: "50px", md: "100px" }} textAlign="center">
                <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ base: "12px", md: "28px" }} color={color}>Frequently Asked Questions</Text>

                <Box textAlign="center" mt={{ base: '30px', md: '50px' }}>
                    <Heading
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }}
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }}
                        letterSpacing="-0.25px"
                        color="white"
                    >
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Questions?</Text>
                    </Heading>

                    <Text
                        fontFamily="'Cags Hetonal', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }}
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }}
                        letterSpacing="-0.25px"
                        mt="10px"
                    >
                        <Text as="span" color={color}>Your </Text>
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Answers </Text>
                        <Text as="span" color={color} fontFamily="'Gilroy-SemiBold', sans-serif">are here  </Text>
                    </Text>
                </Box>
            </Box>
            <BrandingInfoList />

            {/* Contact Section */}
            <Text color={color} mt={{ base: "40px", md: "100px" }} fontSize={{ base: '12px', md: '28px' }} textAlign='center' fontFamily="'Gilroy-Medium', sans-serif">
                Get In Touch
            </Text>
            <Boxx />
            <Footer />
        </Grid>
    );
};

interface BrandingInfoProps {
    title: string;
    content: string;
}

const BrandingInfo: React.FC<BrandingInfoProps> = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bg = useColorModeValue('white', '#1C1C1C');
    const color = useColorModeValue('#FFFFF', 'white');
    const {colorMode} = useColorMode()
    return (
        <Box
            bg={bg}
            maxW="auto"
            borderRadius={{ base: '10px', md: '20px' }}
            color={color}
            border={isOpen ? '1px solid #FE3A3A' : 'none'}
            overflow="hidden"
            mt={{ base: '10px', md: '14px' }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                onClick={() => setIsOpen(!isOpen)}
                cursor="pointer"
                alignItems="center"
                border={isOpen ? '2px solid #FE3A3A' : 'none'}
                borderRadius="md"
                p={{ base: '10px', md: '20px' }}
                backgroundColor={isOpen ? '#FE3A3A' : 'transparent'}
            >
                <Text
                    color={(colorMode == "light" && isOpen) ? "white" : colorMode == "dark" ? "white" : "black"}
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontWeight="400"
                    fontSize={{ base: "16px", md: "32px" }}
                    lineHeight={{ base: "24px", md: "40px" }}
                >
                    {title}
                </Text>
                <IconButton
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    fontSize={{ base: "24px", md: "30px" }}
                    variant="outline"
                    color={color}
                    borderColor={"white"}
                    _hover={{ bg: 'transparent' }}
                    p={{ base: 1, md: 1 }}
                />
            </Box>
            <Box p={isOpen ? 4 : 0} maxH={isOpen ? 'auto' : '0'} transition="max-height 0.2s ease-out">
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "16px", md: "28px" }}
                    lineHeight={{ base: '24px', md: '36px' }}
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
};

const BrandingInfoList: React.FC = () => {
    return (
        <Box>
            <BrandingInfo title="Why is branding important for my business?" content="Strong branding helps your business stand out, builds trust, and fosters customer loyalty. In a competitive market like India, an effective brand identity makes your business recognizable and memorable." />
            <BrandingInfo title="How long does it take to develop a brand identity?" content="On average, it takes about 4-6 weeks to finalize a brand identity, including your logo, typography, and color scheme, depending on the complexity and your needs." />
            <BrandingInfo title="Can you help with both online and offline branding?" content="Yes, we provide end-to-end branding solutions that cover digital platforms (website, social media) and offline materials like brochures, packaging, and business cards." />
            <BrandingInfo title="As a startup, do I really need a full brand identity?" content="Absolutely. Having a well-defined brand identity from the start helps build trust and credibility, giving you a competitive edge and making your business more recognizable to your target audience." />
            <BrandingInfo title="Can you help my startup create a cost-effective branding strategy?" content="Yes, we understand the budget constraints of startups and offer scalable branding packages that allow you to build a strong brand presence while staying within your budget." />
        </Box>
    );
};

export default Digitalbranding;
